/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-sign/QaItpSignMenu.tsx
 * FILE_ID: JOBHUB-QA-ITP-SIGN-MENU-001
 * PURPOSE: Sign button menu for where to place the signature.
 */
import { PenLine } from 'lucide-react'
import { SIGN_PAGE_CHOICES, type SignPageChoice } from '../itp-export/itpSignPages'

export function QaItpSignMenu({
  open,
  label,
  onToggle,
  onChoose,
}: {
  open: boolean
  label: string
  onToggle: () => void
  onChoose: (choice: SignPageChoice) => void
}) {
  return (
    <span className="relative">
      <button type="button" className="inline-flex h-11 items-center gap-1 rounded border border-border px-2.5 text-[11px] font-medium md:h-auto md:py-1" aria-label={label} aria-expanded={open} onClick={onToggle}>
        <PenLine className="h-3.5 w-3.5" />{label}
      </button>
      {open ? (
        <div className="absolute right-0 top-full z-30 mt-1 w-48 rounded-md border border-border bg-card p-1 shadow-lg">
          {SIGN_PAGE_CHOICES.map((choice) => (
            <button key={choice.value} type="button" className="block w-full rounded px-2 py-1.5 text-left text-xs hover:bg-muted" onClick={() => onChoose(choice.value)}>
              {choice.label}
            </button>
          ))}
        </div>
      ) : null}
    </span>
  )
}
